import { Box, Paper, Typography } from '@mui/material';
import { styled } from '@mui/system';


const Wrapper = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 5
});

const Item = styled(Paper)({
    marginTop: "16px",
    padding: '12px',
    width: '100%'
});

const Title = styled(Typography)({
    fontWeight: '500',
});

const Value = styled(Typography)({

});

const TerminalsResume = ({ espelhos }) => {
    // console.log(espelhos);
    const connectedCount = espelhos ? espelhos.filter(item => item.ConnectionStatus === "Connected").length : 0;

    return (
        <Wrapper>
            <Item elevation={0}>
                <Title>Espelhos Online</Title>
                <Value color='green'>{connectedCount}</Value>
            </Item>
            <Item elevation={0}>
                <Title>Espelhos Offline</Title>
                <Value color='red'>{espelhos.length - connectedCount}</Value>
            </Item>
            <Item elevation={0}>
                <Title>Espelhos Total</Title>
                <Value>{espelhos.length}</Value>
            </Item>
        </Wrapper>
    )
}
export default TerminalsResume;